import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			flexWrap: 'wrap',
			borderRadius: 0,
			minHeight: '100%',
			width: '100%',
		},
		image: {
			height: theme.spacing(14.5),
			width: theme.spacing(14.5),
			marginBottom: theme.spacing(4),
			'& img': {
				width: '100%',
				height: '100%',
				objectFit: 'cover',
				objectPosition: 'center',
				transition: theme.transitions.create('border-radius'),
				borderRadius: ({ rounding }) => (rounding ? `${rounding}%` : null),
			},
		},
		text: {
			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => {
						const alignment = mobileAlignment?.metaValue

						return alignment ? `${alignment} !important` : null
					},
				},
			},
		},
		rootContent: {},
		content: {},
	}),
	{ name: 'Testimonials-Content' },
)

export default useStyles
